import React, { useState } from "react";
import { db } from "../firebaseConfig";
import { collection, doc, setDoc, serverTimestamp } from "firebase/firestore";
import { Mail } from "lucide-react";

const Contacto = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    mensaje: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.nombre || !formData.email || !formData.mensaje) {
      alert("Por favor, completa todos los campos.");
      return;
    }

    setLoading(true);
    try {
      const nombreID = formData.nombre.trim().toLowerCase().replace(/\s+/g, "-");
      await setDoc(doc(collection(db, "contactos"), nombreID), {
        ...formData,
        timestamp: serverTimestamp(),
      });
      alert("Mensaje enviado con éxito");
      setFormData({ nombre: "", email: "", mensaje: "" });
    } catch (error) {
      console.error("Error al enviar el mensaje: ", error);
      alert("Hubo un error al enviar el mensaje. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contacto" className="py-20 bg-[var(--color-bg)] scroll-mt-20">
      <div className="max-w-3xl mx-auto px-6">
        {/* Encabezado */}
        <div className="text-center mb-10">
          <div className="flex justify-center mb-4">
            <Mail className="w-10 h-10 text-[var(--color-accent)]" />
          </div>
          <h2 className="text-3xl font-bold text-[var(--color-dark)]">
            Contáctanos
          </h2>
          <p className="mt-2 text-[var(--color-dark)] opacity-80">
            Déjanos tu mensaje y te responderemos a la brevedad.
          </p>
        </div>

        {/* Formulario */}
        <form
          onSubmit={handleSubmit}
          className="bg-white p-8 shadow-md rounded-xl space-y-6"
        >
          <input
            type="text"
            name="nombre"
            placeholder="Tu Nombre"
            value={formData.nombre}
            onChange={handleChange}
            className="w-full p-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] shadow-sm"
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Tu Email"
            value={formData.email}
            onChange={handleChange}
            className="w-full p-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] shadow-sm"
            required
          />

          <textarea
            name="mensaje"
            placeholder="Tu Mensaje"
            rows="4"
            value={formData.mensaje}
            onChange={handleChange}
            className="w-full p-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] shadow-sm"
            required
          />

          <button
            type="submit"
            className="btn btn-primary w-full"
            disabled={loading}
          >
            {loading ? "Enviando..." : "Enviar"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contacto;


